import React from "react";
import { Row, Col, Typography, Button, Spin } from "antd";
import moment from "moment";
import { motion } from "framer-motion";

export default function DataItem({
  icon,
  iconColor,
  keyName,
  value,
  valueType,
  prefix,
  suffix,
  fieldWidth = 12,
  layout = "horizontal",
  hidden,
  button,
  buttonFunction,
  loading,
}) {
  // Format value based on type
  const formatValue = (val, type) => {
    if (val === null || val === undefined || val === "") return <span style={{ color: "#888", marginLeft: layout === 'vertical' ? '0' : '5px' }}>N/D</span>;

    const formatters = {
      date: () => moment.utc(val).format("DD/MM/YYYY"),
      time: () => val.substring(0, 5),
      integer: () => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      double: () => Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      phone: () => val.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"),
      email: () => val.toLowerCase(),
      string: () => val,
      longString: () => val,
    };

    return formatters[type] ? formatters[type]() : val;
  };

  const formattedValue = formatValue(value, valueType);
  const hasValue = value !== null && value !== undefined && value !== "";

  if (!hasValue && hidden) return null;

  const isVertical = layout === "vertical";

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
      <Row className={`data-row ${isVertical ? 'data-row-vertical' : ''} ${icon ? 'has-icon' : ''}`}>
        <Col span={isVertical ? 24 : fieldWidth} className="data-key">
          {icon && (
            <span
              style={{
                color: hasValue ? iconColor : "#bbb",
                marginRight: "8px",
                width: isVertical ? "20px" : "28px",
                height: isVertical ? "20px" : "28px",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: hasValue ? "rgba(0, 0, 0, 0.0)" : "rgba(0, 0, 0, 0.025)",
                border: hasValue ? "1px solid" : "1px solid rgba(0, 0, 0, 0.025)",
                flexShrink: 0
              }}
            >
              {isVertical ? React.cloneElement(icon, { size: 12 }) : icon}
            </span>
          )}
          <span>{keyName}</span>
        </Col>
        <Col span={isVertical ? 24 : 24 - fieldWidth} className="data-value">
          {loading ? (
            <Spin size="small" />
          ) : (
            <>
              {valueType !== "longString" && (
                <>
                  {hasValue && prefix && <span>{prefix}</span>}
                  {formattedValue}
                  {hasValue && suffix && <strong style={{ marginLeft: "5px" }}>{suffix}</strong>}
                </>
              )}
            </>
          )}
        </Col>
      </Row>

      {valueType === "longString" && hasValue && (
        <div style={{ marginTop: isVertical ? "4px" : "8px", width: "100%", paddingLeft: isVertical ? "28px" : "0" }}>
          <Row gutter={[16, 16]}>
            <Col span={button ? 18 : 24}>
              <Typography.Paragraph ellipsis={{ rows: 2, expandable: true, symbol: "Ver más" }} style={{ textAlign: "justify", margin: 0, color: "#262626", fontWeight: 500 }}>
                {formattedValue}
              </Typography.Paragraph>
            </Col>
            {button && (
              <Col span={6} style={{ textAlign: "right" }}>
                <Button type="primary" size="small" onClick={buttonFunction}>
                  {button}
                </Button>
              </Col>
            )}
          </Row>
        </div>
      )}

      {button && valueType !== "longString" && (
        <div style={{ textAlign: "right", marginTop: "8px" }}>
          <Button type="primary" size="small" onClick={buttonFunction}>
            {button}
          </Button>
        </div>
      )}
    </motion.div>
  );
}
